import React from 'react';
import { ScrollArea } from '../../../components/ui/scroll-area';
import { Separator } from '../../../components/ui/separator';
import { CheckCircle2, Circle, Dot, Sparkles } from 'lucide-react';
import FitMatrix from './FitMatrix';

function StepNavigator({
  steps,
  currentStepId,
  questionNotes,
  onSelectStep,
  fitMatrix,
  fitSignals,
  fitAi,
  fitAiLoading,
  fitAiError,
  onSetFitSignal,
  onClearFitSignal,
  onRecheckFit,
  // Synthetic, UI-only final stage appended after the last real script step.
  closeStepId,
  closeStepTitle = 'Close — Pitch or Decline',
}) {
  const onClose = currentStepId === closeStepId;
  return (
    <div className="flex flex-col h-full">
      <h3 className="text-xs font-semibold tracking-wider text-white/40 uppercase mb-3">Call Steps</h3>
      <ScrollArea className="flex-1 pr-2">
        <div className="space-y-1">
          {(steps || []).map((step, idx) => {
            const isActive = step.id === currentStepId;
            const hasNote = Object.values(questionNotes?.[step.id] || {}).some((n) => n && n.trim());
            return (
              <button
                key={step.id}
                onClick={() => onSelectStep(step.id)}
                className={`w-full text-left flex items-center gap-2 px-3 py-2 rounded-lg transition-all ${
                  isActive
                    ? 'bg-[#00d4aa]/20 text-[#00d4aa] border border-[#00d4aa]/30'
                    : 'text-white/70 hover:bg-white/5 hover:text-white'
                }`}
              >
                {hasNote ? (
                  <CheckCircle2 className="w-4 h-4 flex-shrink-0 text-[#00d4aa]" />
                ) : isActive ? (
                  <Dot className="w-4 h-4 flex-shrink-0" />
                ) : (
                  <Circle className="w-4 h-4 flex-shrink-0 text-white/30" />
                )}
                <span className="text-sm truncate">
                  {idx + 1}. {step.title}
                </span>
              </button>
            );
          })}

          {/* Synthetic CLOSE stage — UI-only, not a script.data.steps entry. */}
          {closeStepId && (
            <button
              onClick={() => onSelectStep(closeStepId)}
              className={`w-full text-left flex items-center gap-2 px-3 py-2 rounded-lg transition-all ${
                onClose
                  ? 'bg-[#00d4aa]/20 text-[#00d4aa] border border-[#00d4aa]/30'
                  : 'text-white/70 hover:bg-white/5 hover:text-white'
              }`}
            >
              <Sparkles className="w-4 h-4 flex-shrink-0 text-[#00d4aa]" />
              <span className="text-sm truncate">
                {(steps || []).length + 1}. {closeStepTitle}
              </span>
            </button>
          )}
        </div>
      </ScrollArea>

      {fitMatrix?.length > 0 && (
        <>
          <Separator className="my-3 bg-white/10" />
          <FitMatrix
            fitMatrix={fitMatrix}
            fitSignals={fitSignals}
            fitAi={fitAi}
            fitAiLoading={fitAiLoading}
            fitAiError={fitAiError}
            onSetFitSignal={onSetFitSignal}
            onClearFitSignal={onClearFitSignal}
            onRecheckFit={onRecheckFit}
          />
        </>
      )}
    </div>
  );
}

export default StepNavigator;
